export default "__VITE_ASSET__CO$iyB2g__"